import { render, staticRenderFns } from "./NullifiedPostulatedProjectsList.vue?vue&type=template&id=a31df00c&scoped=true"
import script from "./NullifiedPostulatedProjectsList.vue?vue&type=script&lang=js"
export * from "./NullifiedPostulatedProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31df00c",
  null
  
)

export default component.exports